import { PaymentMethodEnum, PaymentMethodEnumFR, translatePaymentMethod } from './enums/PaymentMethodEnum';
import { PaymentStatusEnum, PaymentStatusEnumFR, translatePaymentStatus } from './enums/PaymentStatusEnum';

export type PaymentModelFR = {
  moyenPaiement: PaymentMethodEnumFR;
  statut: PaymentStatusEnumFR;
  referenceBancaire: string;
  montant: number;
};

export type PaymentModel = {
  paymentMethod: PaymentMethodEnum;
  status: PaymentStatusEnum;
  bankReference: string;
  amount: number;
};

export const translatePaymentModel = (pm: PaymentModelFR): PaymentModel => {
  return {
    paymentMethod: pm.moyenPaiement && translatePaymentMethod(pm.moyenPaiement),
    status: pm.statut && translatePaymentStatus(pm.statut),
    bankReference: pm.referenceBancaire,
    amount: pm.montant,
  };
};
